import { useSelector } from "react-redux";
import TableHeaderCell from "../../common/table/tableHeaderCell";
import { t } from "i18next";
import { useAppDispatch } from "../../../redux";
import { onClickOrder } from "../../../utils/helpers";
import {
  getAdminSurveyReport,
  updateOrder,
  updateOrderAs,
  updatePage,
} from "../../../redux/reducer/surveyReportReducer";

const TableHeader = (props: any) => {
  const dispatch = useAppDispatch();

  const { surveysReport } = useSelector((state: any) => state);
  const { orderBy, orderAs } = surveysReport;

  const OnClickOrder = async (orderType: string) => {
    const { orderOption, listOrderAs } = onClickOrder(
      orderBy,
      orderAs,
      orderType
    );
    dispatch(updateOrder(orderOption));
    dispatch(updateOrderAs(listOrderAs));
    dispatch(updatePage(1));
    dispatch(getAdminSurveyReport());
  };

  const getIcon = (orderType: String) => {
    let icon = "unfold_more";

    if (orderBy === orderType) {
      if (orderAs === "desc") {
        icon = "keyboard_arrow_up";
      } else {
        icon = "keyboard_arrow_down";
      }
    }
    return icon;
  };

  return (
    <thead>
      <tr>
        <TableHeaderCell
          icon={getIcon("name")}
          onClickOrder={() => {
            OnClickOrder("name");
          }}
          label={t("social-region")}
        />
        <TableHeaderCell
          icon={getIcon("city")}
          onClickOrder={() => {
            OnClickOrder("city");
          }}
          label={t("city")}
        />
        <TableHeaderCell
          icon={getIcon("regionalCode")}
          onClickOrder={() => {
            OnClickOrder("regionalCode");
          }}
          label={t("region-code")}
        />
        <TableHeaderCell
          icon={getIcon("citizens")}
          onClickOrder={() => {
            OnClickOrder("citizens");
          }}
          label={t("total-citizen")}
        />
        <TableHeaderCell
          icon={getIcon("surveyAnswers")}
          onClickOrder={() => {
            OnClickOrder("surveyAnswers");
          }}
          label={t("total-survey-conducted")}
        />
      </tr>
    </thead>
  );
};

export default TableHeader;
